module.exports = __webpack_public_path__ + "static/img/help4.283814e0.jpg";